import type React from "react";
import * as styles from "./styles";
import { ProModal } from "pro-features/components/Modals/src/ProModal";
import { Button } from "@similarweb/ui-components";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";
import type { ListNotFoundModalProps } from "./ListNotFoundModal.types";

const ListNotFoundModal: React.FC<ListNotFoundModalProps> = ({ isOpen, toggleOpen }) => {
    const translate = useTranslation();

    return (
        <ProModal
            isOpen={isOpen}
            showCloseIcon={false}
            customStyles={styles.CUSTOM_NOT_FOUND_MODAL_STYLES_}
        >
            <div>
                <styles.StyledModalContent>
                    <styles.StyledTitle>
                        <span>{translate("si.components.not_found_list_modal.title")}</span>
                    </styles.StyledTitle>
                    <styles.StyledDescription>
                        <span>{translate("si.components.not_found_list_modal.subtitle")}</span>
                    </styles.StyledDescription>
                </styles.StyledModalContent>
                <styles.StyledModalFooter>
                    <Button
                        type="flat"
                        onClick={() => toggleOpen(false)}
                    >
                        {translate("si.components.not_found_list_modal.button")}
                    </Button>
                </styles.StyledModalFooter>
            </div>
        </ProModal>
    );
};

export default ListNotFoundModal;
